import { useState } from "react";
import TiposOTTab from "./TiposOTTab";
import OperariosTab from "./OperariosTab";
import VehiculosTab from "./VehiculosTab";

const SUB_TABS = [
  { id: "tipos", label: "Tipos de OT" },
  { id: "operarios", label: "Operarios" },
  { id: "vehiculos", label: "Vehículos" },
];

export default function OTTab() {
  const [active, setActive] = useState("tipos");

  return (
    <div className="space-y-4">
      <div className="flex gap-1 bg-gray-100 rounded-lg p-1 w-fit">
        {SUB_TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActive(tab.id)}
            className={`px-4 py-1.5 text-sm rounded-md transition-colors ${
              active === tab.id
                ? "bg-white text-gray-900 font-medium shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {active === "tipos" && <TiposOTTab />}
      {active === "operarios" && <OperariosTab />}
      {active === "vehiculos" && <VehiculosTab />}
    </div>
  );
}
